<template>
	<el-dialog :title="title" v-model="dialogVisible" width="30%" :before-close="handleClose">
		<el-form :label-position="labelPosition" label-width="130px" ref="form" :model="form" :rules="rules">
			<el-form-item label="保安名称:" prop="name">
				<el-input v-model="form.name" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="账号:" prop="memberUserName">
				<el-input v-model="form.memberUserName" autocomplete="off"
					:disabled="this.title != '修改管理员'?false:true"></el-input>
			</el-form-item>
			<el-form-item label="手机号:" prop="mobile">
				<el-input v-model="form.mobile" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="登陆密码:">
				<el-input v-model="form.password" autocomplete="off"></el-input>
			</el-form-item>
			
			<el-form-item label="头像:">
				<!-- <el-input  v-model="form.name"  autocomplete="off"></el-input> -->
				<img v-if="picImage != ''" :src="picImage" @click="selectFile" style="height: 40px; width: 30px;">

				<img v-else src="../../img/add-face.png" @click="selectFile()" style="height: 30px; width: 30px">

				<input type="file" style="display: none" ref="fileInput" accept=".png, .jpg, .jpeg"
					@change="handleFileChange">

			</el-form-item>
			<div class="buttom-box">
				<el-button type="primary" @click="onSubmit('form')" :loading="loading">提交</el-button>
				<el-button size="small" @click="handleClose">返回</el-button>
			</div>
		</el-form>

	</el-dialog>
</template>
<script>
	import {
		LoDongBuildingList,
		uploadImage,
	} from '@/assets/api/schoollog.js'
	import {
		findTeacherInfo,
	} from '@/assets/api/renyuan';
	import {
		memberAddInfo,
		memberUpdate,
		memberDetailsInfo
	} from '@/assets/api/logapi';
	import {
		userTree
	} from '@/assets/api/api'

	export default {
		components: {},
		props: ['detailsObj'],
		data() {

			return {
				dialogVisible: true,
				loading: false,
				labelPosition: 'left',
				title: '',
				form: {
					name: '',
					memberUserName: "",
					mobile: "",
					password: null,
					orgCode: "",
				},
				schoolList: [],
				schoolInfo: {},
				title: '',
				cityOptions: [],
				checkedCities: [],
				rules: {
					name: [{
						required: true,
						message: '请输入保安名称',
						trigger: 'blur'
					}, ],
					memberUserName: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}, ],
					mobile: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}, ],
					// pointType: [
					//         { required: true, message: '请选择类型', trigger: 'blur' },
					//       ],
				},
				itemData: {},
				tempFile: '',
				picImage: ''
			}

		},
		created() {
			this.Lookteacher()
			this.menuGetUserTreeGet()
			if (JSON.stringify(this.detailsObj) != '{}') {
				this.title = '修改管理员'
				console.log(this.detailsObj, '000000000000');
				this.form.name = this.detailsObj.name
				this.form.memberUserName = this.detailsObj.memberUserName
				this.form.mobile = this.detailsObj.mobile
				this.form.name = this.detailsObj.name
				this.picImage = this.detailsObj.logo
			} else {
				this.title = '添加管理员'
			}
			this.Getinfo()
		},
		mounted() {

		},
		methods: {
			handleCheckedCitiesChange(val) {
				console.log(val, '多选1111');
			},
			onSubmit(formName) {
				console.log(formName);
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.title == '修改管理员') {
							this.EditGuabLiYuan()
						} else if (this.title == '添加管理员') {
							this.addGuabLiYuan()
						}
					} else {
						return false;
					}
				});
			},
			Getinfo() {
				memberDetailsInfo(this.detailsObj.id).then((res) => {
					// this.detailsObj = res.data.data
					// console.log(this.detailsObj);
					this.form.memberUserName = res.data.data.memberUserName
					res.data.data.buildings.forEach((item) => {
						this.checkedCities.push(item.buildingId)
					});
					console.log(res, 11111);
					// this.AddShow = true
				}).catch((err) => {
					console.log(err, 'shibai');
				})
			},
			
			//修改
			EditGuabLiYuan() {
				const params = {
					name: this.form.name,
					memberUserName: this.form.memberUserName,
					mobile: this.form.mobile,
					password: this.form.password,
					checkPassword: this.form.password,
					dormitoryManager: 2,
					logo: this.picImage,
					orgCode: this.form.orgCode,
					sex: 0,
					memberId: this.detailsObj.id,
					buildingIds: this.checkedCities,
				}
				memberUpdate(params).then((res) => {
					this.$message({
						message: '修改成功',
						type: 'success'
					});
					this.handleClose()
				}).catch((err) => {
					// this.$message.error('新增失败');
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},
			//新增
			addGuabLiYuan() {
				const params = {
					name: this.form.name,
					memberUserName: this.form.memberUserName,
					mobile: this.form.mobile,
					password: this.form.password,
					checkPassword: this.form.password,
					dormitoryManager: 2,
					logo: this.picImage,
					orgCode: this.form.orgCode,
					sex: 0,
					buildingIds: this.checkedCities,
					schoolId: this.schoolInfo.schoolId
				}
				memberAddInfo(params).then((res) => {
					this.$message({
						message: '新增成功',
						type: 'success'
					});
					this.handleClose()
				}).catch((err) => {
					// this.$message.error('新增失败');
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},
			selectFile(item) {
				this.$refs.fileInput.click();
				this.itemData = item;

			},
			handleFileChange(event) {
				console.log(event.target.files[0], '选择');
				this.tempFile = event.target.files[0];
				let formData = new FormData();
				formData.append("file", this.tempFile);
				uploadImage(formData, this.tempFile.name).then((res) => {
					// console.log(res.data.data.picImage);
					this.picImage = res.data.data.picImage
					// ElMessage({ message: '', type: 'success', })

				}).catch((err) => {
					// console.log();
				})


			},
			Lookteacher() {
				let params = {
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				findTeacherInfo(params).then((res) => {
					console.log(res, '查看权限');
					this.schoolInfo = res.data.data
					this.getLouDong()
				}).catch((err) => {
					console.log(err);
				})
			},
			getLouDong() {
				let params = {
					schoolId: this.schoolInfo.schoolId,
					page: '1',
					pageSize: '9999',
				}
				LoDongBuildingList(params).then((res) => {
					this.cityOptions = res.data.data.list
					console.log('管理楼栋', this.cityOptions, res.data.data);
				}).catch((err) => {
					console.log(err);
				})
			},

			handleClose() {
				this.$emit('AddShowClick')
			},
			//获取org-code
			menuGetUserTreeGet() {
				const params = {
					userId: JSON.parse(localStorage.getItem('user')).id
				};
				userTree(params).then((res) => {

					this.form.orgCode = res.data.data[0].orgCode
					//   console.log(this.form.orgCode,res.data.data,'0000000000');
				}).catch((err) => {
					console.log(err);
				})
			},


		}
	}
</script>
<style scoped lang="scss">
	/deep/ {

		.el-input--small .el-input__wrapper {
			height: 35px;
			line-height: 35px;
			text-align: center;
			width: 280px;
			// margin-top: ;
		}

		.el-input__inner {
			// width: 10px !important;
		}

		.buttom-box {
			// text-align: center;
			margin-left: 13%;
			// margin-top: 35px;

		}

		.el-form-item--small {
			width: 70% !important;
		}
	}
</style>